import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";

import { validaSoloNumero, validaMonto, formatoMonto } from "../../util/varios";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import CatalogoContable from "../../catalogos/catalogoContable";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";
import { Input, SearchInput } from "../../ui/inputs/Input";

export const ModalVincularCaja = (props) => {
  let op = require("../../../src/modulos/datos");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [msg2, setMsg2] = useState();
  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [visible, setVisible] = useState(false);
  const txtId = useRef();
  const txtDescrip = useRef();
  const txtPorcen = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  let token = localStorage.getItem("jwtToken");

  const validarCampos = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtId.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe Ingresar una cuenta contable.",
        icono: "informacion",
      });
      sigue = false;
      txtId.current.focus();
    }
    if (sigue) {
      actualizarVinculacion(props.operacion);
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.setShow(false);
  };

  const actualizarVinculacion = () => {
    let endpoint = `${op.conexion}/api/contabilidadfis/vincularcaja?idefiscal=${idefiscal}&id=${txtId.current.value}`;
    setActivate(true);
    axios
      .post(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Vinculacion Exitosa.",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const blanquearCampos = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setOperacion();
    setDeshabilitado();
    setVisible();
  };
  const salir = () => {
    props.setShow(false);
    blanquearCampos();
  };
  const seleccionarCuenta = (id) => {
    setMostrar(false);
    let endpoint = `${op.conexion}/api/contabilidadfis/selectctaconta?id=${id}&idefiscal=${idefiscal}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtId.current.value = response.data.idcuentacontable;
            txtDescrip.current.value = response.data.descripcion;
            setActivate(false);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe una Cuenta Contable con este Codigo.",
              icono: "informacion",
            });
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const validarCuenta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    txtDescrip.current.value = "";
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarCuenta(event.target.value);
      } else {
      }
    }
  };

  const seleccionarRegistro = () => {
      let endpoint = `${op.conexion}/api/contabilidadfis/selectcuentacaja?idefiscal=${idefiscal}`;
      axios
        .get(endpoint, {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            if (response.data.idcuentacontable > 0) {
              txtId.current.value = response.data.idcuentacontable;
              seleccionarCuenta(response.data.idcuentacontable);
            }
          }
          setActivate(false);
        })
        .catch(function (error) {
          setMensaje({
            mostrar: true,
            titulo: "ERROR",
            texto: error.response.data.message,
            icono: "error",
          });
          setActivate(false);
        });
    };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setDeshabilitado(props.deshabilitado);
        setOperacion(props.operacion);
        setVisible(false);
        seleccionarRegistro();
      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold m-0">Vincular Caja</h3>
        <a
          type="button"
          ref={btnCancela}
          onClick={salir}
          className="text-light fw-bold fs-6"
        >
          Salir<i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
          <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
            <legend className="float-none w-auto">
              Relacion Cuenta Contable
            </legend>
              <SearchInput label = 'Caja:'
                name="idcuentabancaria"
                onKeyUp={validarCuenta}
                onBlur={validarCuenta}
                onClickButton={() => { setMostrar(true) }}
                ref={txtId}
              />
              <Input
                id="codigocuenta"
                disabled
                name="codigocuenta"
                ref={txtDescrip}
              />
          </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={operacion === 4 ? true : false}
          onClick={validarCampos}
          ref={btnAcepta}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          onClick={salir}
          ref={btnCancela}
        >
            Salir
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <Dimmer active={activate} inverted></Dimmer>
      <CatalogoContable
        show={mostrar}
        onHideCancela={() => {
          setMostrar(false);
        }}
        onHideAcepta={seleccionarCuenta}
      />
    </Modal>
  );
};
